import * as React from "react"
import { Link } from "gatsby"

const Button = props => {
  const ButtonColour = {
    primary:
      "bg-blue-600 border-blue-600 text-white hover:bg-blue-500 hover:border-blue-500",
    secondary:
      "bg-none border-blue text-white hover:bg-blue-600 hover:border-blue-600",
    dark: "bg-navy border-navy text-white hover:bg-blue-500 hover:border-blue-500",
    blue: "bg-blue-600 border-blue-600 text-white hover:bg-navy hover:border-navy",
  }

  const buttonStyle = `${
    props.fullWidth ? "w-full " : ""
  }group inline-flex flex-row items-center justify-between py-3 px-6 lg:px-8 border-2 font-normal uppercase tracking-widest ${
    ButtonColour[props.variant]
  } transition duration-500 ease-in-out`

  if (props.href) {
    return (
      <a
        className={buttonStyle}
        href={props.href}
        target={props.target}
        rel={props.rel}
      >
        {props.children}

        <span
          className={`ml-2 transition duration-500 ease-in-out ${
            props.variant === "primary"
              ? "text-blue-700 group-hover:text-white"
              : "text-blue group-hover:text-blue-700"
          }`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={"2"}
            className={`w-4 h-4 stroke-current`}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
            />
          </svg>
        </span>
      </a>
    )
  } else if (props.to) {
    return (
      <Link className={buttonStyle} to={props.to}>
        {props.children}

        <span
          className={`ml-2 transition duration-500 ease-in-out ${
            props.variant === "primary"
              ? "text-blue-700 group-hover:text-white"
              : "text-blue group-hover:text-blue-700"
          }`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={"2"}
            className={`w-4 h-4 stroke-current`}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
            />
          </svg>
        </span>
      </Link>
    )
  } else {
    return (
      <button className={buttonStyle} onClick={props.onClick} type={"submit"}>
        {props.children}

        <span
          className={`ml-2 transition duration-500 ease-in-out ${
            props.variant === "primary"
              ? "text-blue-700 group-hover:text-white"
              : "text-blue group-hover:text-blue-700"
          }`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={"2"}
            className={`w-4 h-4 stroke-current`}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
            />
          </svg>
        </span>
      </button>
    )
  }
}

export default Button
